.treeContainer {
  display: flex;
  height: 100vh;
  //flex: 1;
  //min-width: 0;
}

.tree {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.row {
  white-space: nowrap;
  cursor: pointer;
}

.node {
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 20px;
  height: 100%;
}

.node:global(.willReceiveDrop) {
  background: #bbb;
}

.node:global(.isSelected) {
  background: var(--bs-primary);
  color: white;
}

.tree:hover .indentLines {
  display: flex;
}

.indentLines {
  --indent-size: 15px;

  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  display: none;
  align-items: flex-start;
  height: 100%;
}

.indentLines > div {
  height: 100%;
  padding-left: 15px;
  border-right: 1px solid var(--bs-black);
  margin-right: calc(var(--indent-size) - 10px - 1px);
}

.row:focus {
  outline: none;
}

.row:focus .node {
  background: #ddd;
}

.row:focus .node:global(.isSelected) {
  background: var(--bs-primary);
}

.text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.node:global(.isInternal) {
  cursor: pointer;
}
